import React from "react";
import './Footer.scss';

const Footer = () => {
  return (
    <footer className="small mainfooter">
      <div className="container-fluid dashboard-footer d-flex justify-content-between">
          <span>© 2026 ZavzaSeal</span>
          <span>Designed by ZavzaSeal Team</span>
        </div>
    </footer>
  );
};

export default Footer;